export const shareProductWhatsApp = (product, e) => {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  const isAuction = product.sale_type === "auction";
  const price = isAuction ? (product.current_bid || product.price) : (product.buy_now_price || product.price);
  const url = `${window.location.origin}/product/${product.product_id}`;
  const label = isAuction ? `Subasta activa — puja actual $${price}` : `Precio $${price}`;
  const text = `\u00A1Mira este producto en Clueer!\n\n*${product.title}*\n${label}\n\n${url}`;
  window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank", "noopener");
};
